import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import type { CounselingCenterStatistics as CounselingCenterStatisticsType } from '../../../common/types/statistics/fhbfStatistics';
import InformationStatistic from './InformationStatistic';
import OptionStatistics from './OptionStatistics';
import MeasureStatistics from './MeasureStatistics';
import ReferralStatistics from './ReferralStatistics';

type Props = {
  statistics: CounselingCenterStatisticsType;
};

function CounselingCenterStatistics({ statistics }: Props) {
  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0',
        padding: '20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Stack>
        <Typography fontSize='1.2rem' fontWeight='bold' mb={1}>
          Fallauswertung
        </Typography>
        <InformationStatistic statistics={statistics} />
        <OptionStatistics statistics={statistics} />
        <ReferralStatistics statistics={statistics} />
        <MeasureStatistics statistics={statistics} />
      </Stack>
    </Paper>
  );
}

export default CounselingCenterStatistics;
